import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: "#6F0D0B",
        },
        error:{
            main: "#FF3D00"
        },
    },
    
    typography: {
        fontFamily: "Rubik",
        h6: {
            fontWeight: '500',
            color: "rgba(0, 0, 0, 0.87)"
        },
        subtitle1: {
            color: "rgba(0, 0, 0, 0.5)",
            fontSize: "0.72rem",
            fontWeight: "400",
        }
        , subtitle2: {
            color: "rgba(0, 0, 0, 0.5)",
            fontSize: "16px",
            fontWeight: "400",
            fontFamily: "Roboto"
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "Roboto",
                    fontWeight: "normal",
                },
            },
        },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    h1: 'h2',
                    h2: 'h2',
                    h3: 'h2',
                    h4: 'h2',
                    h5: 'h2',
                    h6: 'h2',
                    subtitle1: 'h2',
                    subtitle2: 'h2',
                    body1: 'span',
                    body2: 'span',
                },
            },
        },
    },
});

export default theme;